import "../App.css";
import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import BevHeader from "../BevHeader";
import BevFooter from "../BevFooter";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import GadgetRegistration from "./GadgetRegistration";
import AutoRegistration from "./AutoRegistration";
import FurnitureRegistration from "./FurnitureRegistration";
import TravelRegistration from "./TravelRegistration";
import EventsRegistration from "./EventsRegistration";
import AgricultureRegistration from "./AgricultureRegistration";
import ManufacturingRegistration from "./ManufacturingRegistration";
import Logo from "../../assets/logo.jpg";
import { getCategoryFromSlug } from "./categoryFromSlug";

const Registration = () => {
  const [searchParams] = useSearchParams();
  const [category, setCategory] = useState(() =>
    getCategoryFromSlug(searchParams.get("category"))
  );

  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
  };

  return (
    <>
      <BevHeader />
      <div className="registration-form-container">
        <div className="registration-form">
          <img src={Logo} alt="Logo" width={120} className="form-logo" />
          <Typography variant="h4" align="center" gutterBottom>
            Bevogtet Registration
          </Typography>
          <div className="category-selector">
            <FormControl component="fieldset">
              <RadioGroup
                row
                aria-label="category"
                name="category"
                value={category}
                onChange={handleCategoryChange}
              >
                <FormControlLabel
                  value="Gadgets"
                  control={<Radio color="success" />}
                  label="Gadgets & Electronics"
                />
                <FormControlLabel
                  value="Auto"
                  control={<Radio color="success" />}
                  label="Automobiles"
                />
                <FormControlLabel
                  value="Furniture"
                  control={<Radio color="success" />}
                  label="Furniture"
                />
                <FormControlLabel
                  value="Travel"
                  control={<Radio color="success" />}
                  label="Travel"
                />
                <FormControlLabel
                  value="Events"
                  control={<Radio color="success" />}
                  label="Events"
                />
                <FormControlLabel
                  value="Agriculture"
                  control={<Radio color="success" />}
                  label="Agriculture"
                />
                <FormControlLabel
                  value="Manufacturing & Goods"
                  control={<Radio color="success" />}
                  label="Manufacturing & Goods"
                />
              </RadioGroup>
            </FormControl>
          </div>
          {category === "Gadgets" && <GadgetRegistration />}
          {category === "Auto" && <AutoRegistration />}
          {category === "Furniture" && <FurnitureRegistration />}
          {category === "Travel" && <TravelRegistration />}
          {category === "Events" && <EventsRegistration />}
          {category === "Agriculture" && <AgricultureRegistration />}
          {category === "Manufacturing & Goods" && (
            <ManufacturingRegistration />
          )}
        </div>
      </div>
      <BevFooter />
    </>
  );
};

export default Registration;
